module.exports = __webpack_public_path__ + "static/media/success.2b535ec2.gif";